var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{
    [_vm.disciplineName]: _vm.chip,
    'chip white--text  px-2 mr-2': _vm.chip,
    'chip-smaller': _vm.chip && !_vm.large,
    'large-chip': _vm.chip && _vm.large,
    'secondary--text': !_vm.chip
  }},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }